// Sistema de rutas centralizado y escalable
// Define todas las rutas de la aplicación con sus layouts correspondientes

import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Componentes de página
import { Login, RegisterScreen, ForgotPassword, ResetPassword } from '../pages/auth';
import { Profile, FriendProfileScreen, UserImpeachmentScreen, AfterCreateImpeachmentScreen } from '../pages/profile';
import ChatScreen from '../pages/chat/ChatScreen';
import ChatRoomScreen from '../pages/chat/ChatRoomScreen';
import ChatScreenV2 from '../pages/chat/ChatScreenV2';
import { Interacciones } from '../pages/interacciones';
import { MiCuenta, Configuracion, AlbumesListManagerPage, EditarPerfil, GestionCuenta, UpdateEmailScreen, UpdatePasswordScreen, CloseAccountScreen } from '../pages/mi-cuenta';
import { Radar } from '../pages/radar';
import HomePublic from '../pages/Home';
import Planes from '../pages/home-private/Planes';
import Premium from '../pages/Premium';
import SubscriptionSuccess from '../pages/subscription/SubscriptionSuccess';
import MercadoPagoReturnHandler from '../pages/subscription/MercadoPagoReturnHandler';
import { EcommerceSuccess, EcommerceFailure, EcommercePending, Tienda } from '../pages/ecommerce';
import PoliticasEasi from '../pages/legal/PoliticasEASI';
import Privacidad from '../pages/legal/Privacidad';
import TerminosCondicionesCompras from '../pages/legal/TerminosCondicionesCompras';

// Componentes de redirección
import HomeRoute from '../components/HomeRoute';
import { MainLayout } from '../components/Layout';

// Componentes de rutas protegidas
import ProtectedRoute from '../components/ProtectedRoute';
import PublicRoute from '../components/PublicRoute';

/**
 * Componente AppRoutes
 * 
 * Sistema centralizado de rutas con layouts configurados
 * Escalable para agregar nuevas rutas fácilmente
 */
const AppRoutes = () => {
  return (
    <Routes>
      {/* Ruta principal con manejo condicional según autenticación */}
      <Route path="/" element={<HomeRoute />} />
      <Route path="/premium" element={<Premium />} />
      <Route path="/politicas-easi" element={<PoliticasEasi />} />
      <Route path="/privacidad" element={<Privacidad />} />
      <Route path="/terminos-compras" element={<TerminosCondicionesCompras />} />

      {/* Rutas públicas con AuthLayout */}
      <Route
        path="/auth/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/auth/register"
        element={
          <PublicRoute>
            <RegisterScreen />
          </PublicRoute>
        }
      />

      <Route
        path="/auth/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />

      <Route
        path="/auth/reset-password"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />

      {/* Rutas protegidas con MainLayout - Chats */}
      <Route
        path="/chats"
        element={
          <ProtectedRoute>
            <MainLayout hideNavbar={true}>
              <ChatScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/chats/chatroom"
        element={
          <ProtectedRoute>
            <MainLayout hideNavbar={true} hideNavbarBottom={true}>
              <ChatRoomScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Rutas protegidas con MainLayout - Chats V2 (MUI Chat) */}
      {/* <Route
        path="/v2/chats"
        element={
          <ProtectedRoute>
            <MainLayout hideNavbar={true}>
              <ChatScreenV2 />
            </MainLayout>
          </ProtectedRoute>
        }
      /> */}

      {/* Rutas protegidas con MainLayout - Interacciones */}
      <Route
        path="/interacciones"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Interacciones />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Rutas protegidas con MainLayout - Radar */}
      <Route
        path="/radar"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Radar />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Rutas protegidas con MainLayout - Planes */}
      <Route
        path="/planes"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Planes />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Rutas protegidas con MainLayout - Tienda */}
      <Route
        path="/tienda"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Tienda />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Ruta intermedia para manejar retorno de Mercado Pago */}
      <Route
        path="/mp-return"
        element={
          <ProtectedRoute>
            <MainLayout>
              <MercadoPagoReturnHandler />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Ruta de retorno de Mercado Pago */}
      <Route
        path="/suscripcion/return"
        element={
          <ProtectedRoute>
            <MainLayout>
              <SubscriptionSuccess />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Rutas de e-commerce para Mercado Pago */}
      <Route
        path="/ecommerce/success"
        element={
          <ProtectedRoute>
            <MainLayout>
              <EcommerceSuccess />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/ecommerce/failure"
        element={
          <ProtectedRoute>
            <MainLayout>
              <EcommerceFailure />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/ecommerce/pending"
        element={
          <ProtectedRoute>
            <MainLayout>
              <EcommercePending />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Rutas protegidas con MainLayout - Mi Cuenta */}
      <Route
        path="/mi-cuenta"
        element={
          <ProtectedRoute>
            <MainLayout>
              <MiCuenta />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mi-cuenta/configuracion"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Configuracion />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mi-cuenta/albumes"
        element={
          <ProtectedRoute>
            <MainLayout>
              <AlbumesListManagerPage />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mi-cuenta/editar"
        element={
          <ProtectedRoute>
            <MainLayout>
              <EditarPerfil />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mi-cuenta/gestion"
        element={
          <ProtectedRoute>
            <MainLayout>
              <GestionCuenta />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mi-cuenta/gestion/cambiar-email"
        element={
          <ProtectedRoute>
            <MainLayout>
              <UpdateEmailScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mi-cuenta/gestion/cambiar-password"
        element={
          <ProtectedRoute>
            <MainLayout>
              <UpdatePasswordScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/mi-cuenta/gestion/desactivar-cuenta"
        element={
          <ProtectedRoute>
            <MainLayout>
              <CloseAccountScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Profile />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile/:friendId"
        element={
          <ProtectedRoute>
            <MainLayout>
              <FriendProfileScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/report"
        element={
          <ProtectedRoute>
            <MainLayout>
              <UserImpeachmentScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/report/confirmation"
        element={
          <ProtectedRoute>
            <MainLayout>
              <AfterCreateImpeachmentScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Ruta privada para perfil de amigo - usa location.state para no exponer UUIDs */}
      <Route
        path="/friend/profile"
        element={
          <ProtectedRoute>
            <MainLayout>
              <FriendProfileScreen />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Rutas legales protegidas - disponibles para usuarios autenticados con MainLayout */}
      <Route
        path="/politicas-easi"
        element={
          <ProtectedRoute>
            <MainLayout>
              <PoliticasEasi />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/privacidad"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Privacidad />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/terminos-compras"
        element={
          <ProtectedRoute>
            <MainLayout>
              <TerminosCondicionesCompras />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Ruta por defecto - redirige a la home pública */}
      <Route path="*" element={<HomePublic />} />
    </Routes>
  );
};

export default AppRoutes;
